export const footerDataEN = [
  {
    label: 'About Blue Cross',
    value: '1',
    children: [
      {
        value: '1-1',
        label: 'About Us',
        href: '/en/AboutBlueCross/Information/CompanyProfile',
      },
      {
        value: '1-2',
        label: 'News Room',
        href: '/en/AboutBlueCross/Information/NewsRoom',
      },
      {
        value: '1-3',
        label: 'Our Awards',
        href: '/en/AboutBlueCross/Information/CompanyAwards',
      },
      {
        value: '1-4',
        label: 'Corporate Social Responsibility',
        href: '/en/AboutBlueCross/Information/SocialResponsibility',
      },
      {
        value: '1-5',
        label: 'Careers',
        href: '/en/career-opportunities/Information',
      },
    ],
  },
  {
    label: 'Blog',
    value: '3',
    children: [
      {
        value: '3-1',
        label: 'ALL',
        href: 'https://just-right.bluecross.com.hk/blog/all',
        target: '_blank',
      },
      {
        value: '3-2',
        label: 'Health',
        href: 'https://just-right.bluecross.com.hk/blog/health',
        target: '_blank',
      },
      {
        value: '3-3',
        label: 'Life',
        href: 'https://just-right.bluecross.com.hk/blog/life',
        target: '_blank',
      },
      {
        value: '3-4',
        label: 'Pet',
        href: 'https://just-right.bluecross.com.hk/blog/pet',
        target: '_blank',
      },
      {
        value: '3-5',
        label: 'Travel',
        href: 'https://just-right.bluecross.com.hk/blog/travel',
        target: '_blank',
      },
      {
        value: '3-6',
        label: 'Protection',
        href: 'https://just-right.bluecross.com.hk/blog/protection',
        target: '_blank',
      },
    ],
  },
  {
    label: 'Contact Us',
    value: '2',
    children: [
      {
        value: '2-1',
        label: 'Tel：(852) 2839 6333',
        icon: 'mobile',
        href: 'tel:+85228396333',
      },
      {
        value: '2-2',
        icon: 'email',
        label: 'Email：cs@bluecross.com.hk',
      },
      {
        value: '2-3',
        icon: 'fax',
        label: 'Fax：(852) 2263 7517',
      },
      {
        value: '2-4',
        icon: 'customer-service',
        label: 'Customer Service Centre',
        children: [
          {
            label: 'Monday to Friday',
          },
          {
            label: '9:00am - 5:30pm',
          },
          {
            label: 'Closed on Saturday, Sunday and Public Holidays',
          },
        ],
      },
      {
        value: '2-5',
        icon: 'location',
        label: 'Address:',
        children: [
          {
            label:
              "54/F, Hopewell Centre, 183 Queen's Road East, Wan Chai, Hong Kong Island, Hong Kong",
          },
        ],
      },
    ],
  },

  {
    label: 'Talk To Us',
    value: '5',
    children: [
      {
        value: '5-1',
        label: 'Comment/Enquiry',
        icon: 'conversation',
        href: '/en/Contact-Us/Online-Enquiry',
      },
      {
        value: '5-2',
        label: 'Download Blue Cross HK App',
        children: [
          {
            value: '5-2-1',
            href: 'https://play.google.com/store/apps/details?id=hk.com.bluecross.mobileapp',
            target: '_blank',
            type: 'GooglePlay',
            icon: '/images/CorporateWebsite/Icon/googleplay.png',
          },
          {
            value: '5-2-2',
            href: 'https://apps.apple.com/hk/app/blue-cross-hk/id1441274976',
            target: '_blank',
            type: 'AppStore',
            icon: '/images/CorporateWebsite/Icon/appstore.png',
          },
        ],
      },
    ],
  },
  {
    label: 'Legal Notices',
    value: '6',
    children: [
      {
        value: '6-1',
        label: 'Disclaimer',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/Disclaimer/en',
      },
      {
        value: '6-3',
        label: 'Collection Of Premium Levy By The Insurance Authority',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/levy_collection/en',
      },
      {
        value: '6-4',
        label: 'Personal Information Collection Statement',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/pics_bcaia/en',
      },
      {
        value: '6-5',
        label: 'Privacy Policy Statement',
        href: 'https://ap.bluecross.com.hk/Routing/document/general/eprivacy/en',
      },
    ],
  },
];

export const mediaDataEN = [
  {
    value: '1',
    href: 'https://www.facebook.com/BlueCrossHK/',
    icon: 'facebook',
    target: '_blank',
  },
  {
    value: '2',
    href: 'https://www.instagram.com/bluecrosshk',
    icon: 'instagram',
    target: '_blank',
  },
  {
    value: '3',
    href: 'https://www.youtube.com/channel/UC6_r0jCRF9iMXod58WwQYzQ',
    icon: 'youtube',
    target: '_blank',
  },
  {
    value: '4',
    href: 'https://www.linkedin.com/company/blue-cross-asia-pacific-insurance-limited',
    icon: 'linkedin',
    target: '_blank',
  },
];

export const mobileStoreDataEN = [
  {
    value: '1',
    href: 'https://play.google.com/store/apps/details?id=hk.com.bluecross.mobileapp',
    target: '_blank',
    type: 'GooglePlay',
    icon: '/images/CorporateWebsite/Icon/googleplay.png',
  },
  {
    value: '2',
    href: 'https://apps.apple.com/hk/app/blue-cross-hk/id1441274976',
    target: '_blank',
    type: 'AppStore',
    icon: '/images/CorporateWebsite/Icon/appstore.png',
  },
];
